// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag-menu-item .dropdown-item{position:relative;padding:10px 20px 10px 15px!important}.tag-menu-item .marked-tag{position:absolute;right:5px;top:7px}", ""]);
// Exports
module.exports = exports;
